export class TblLeadCampaign {
    refNo:number;
    campaignName:string

    currenttStatus:string

}